import { useLanguage } from "@/shared/hooks/use-language";
import { cn } from "@/lib/utils";

interface LanguageToggleProps {
  className?: string;
}

export function LanguageToggle({ className }: LanguageToggleProps) {
  const { language, setLanguage } = useLanguage();

  return (
    <div
      className={cn(
        "flex items-center justify-center gap-2 text-xs text-muted-foreground",
        className,
      )}
      role="group"
      aria-label="Language"
    >
      <button
        type="button"
        onClick={() => setLanguage("en")}
        className={cn(
          "transition-colors hover:text-foreground",
          language === "en" && "text-foreground font-semibold",
        )}
        aria-pressed={language === "en"}
      >
        EN
      </button>
      <span aria-hidden="true">|</span>
      <button
        type="button"
        onClick={() => setLanguage("pt")}
        className={cn(
          "transition-colors hover:text-foreground",
          language === "pt" && "text-foreground font-semibold",
        )}
        aria-pressed={language === "pt"}
      >
        PT
      </button>
    </div>
  );
}
